<template>
  <div>
    <div class="mb-4">
      <div class="location-home pt-2.5">
        <!-- <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3> -->
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="!cardView">
          {{ this.serviceName }}
        </h3>
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="cardView">
          Service Provider
        </h3>
      </div>

      <div class="flex ml-auto lg:mt-0 md:mt-0 mt-4">
        <!-- <b-form-input
          id="input-default"
          label-size="large"
          class=""
        ></b-form-input> -->

        <div class="search">
          <base-button
            @click="handleRoute('request-form', 'request-for-service')"
            type="primary"
            class="search-clr-btn ml-2"
            ><span> Request for Service </span>
            <!-- <span v-if="cardView"> About Service </span> -->
          </base-button>
          <base-button
            @click="handleService"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Know Your Service Provider </span>
          </base-button>
        </div>
      </div>
    </div>
    <div class="" v-show="!cardView">
      <!-- <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      /> -->

      <p>
        <span class="font-bold text-primary"> Service Description:</span>
        Long-term care for a family member with chronic health problems can
        disrupt the balance within a family. In smaller family units, when a
        single member takes on the role of daily caregiving, it often leads to
        burnout, complications, and conflicts. Without adequate family support
        and timely interventions, the caregiving situation can quickly
        deteriorate.
      </p>
      <br />

      <div class="text-777777 font-normal mb-2">
        <span class="font-bold text-primary">
          Why Consider Family Counselling:
        </span>
        Family counselling offers invaluable support for those grappling with
        caregiving challenges:
      </div>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Constructive Engagement: </span>
          Our counselling and therapy sessions engage family caregivers in
          constructive methods to reduce caregiver stress.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Improved Patient Care: </span>
          Learn how to enhance patient care effectively, ensuring your loved one
          receives the best support.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Enhanced Family Welfare: </span>
          Counselling helps improve overall family welfare, fostering a
          healthier environment for everyone involved.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Conflict Resolution: </span>
          Develop problem-solving approaches to reduce conflicts and caregiving
          struggles within the family.
        </li>
      </ul>

      <p>
        <span class="text-primary font-bold"> Our Service:</span> At Caregiver
        Saathi, we recognize the complexities of family caregiving. Our family
        counselling and therapy sessions are designed to empower you with the
        tools and insights needed to navigate these challenges effectively. We
        guide you in building a more harmonious caregiving environment for your
        family.
        <br />
      </p>

      <p class="mt-4">
        <span class="font-bold text-primary mt-2">For Whom:</span> Families
        facing caregiving challenges and seeking constructive solutions.
      </p>

      <h6 class="mt-4 text-primary fsize16 font-bold">Why Choose Us:</h6>

      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">
          Tailored counselling for family caregivers
        </li>

        <li class="text-777777 font-normal">
          Improve patient care and reduce caregiver stress.
        </li>

        <li class="text-777777 font-normal">Enhance overall family welfare.</li>
        <li class="text-777777 font-normal">
          Resolve conflicts and caregiving challenges.
        </li>
      </ul>
      <p class="mb-2 underline">Foster Family Harmony Today!</p>

      <p class="mb-2 text-gray">
        Price: Affordable counselling sessions starting at
        <span class="font-semibold text-dark">INR 2500/ session + 18% GST</span>
      </p>
      <p class="text-gray">
        For 5 or more sessions:
        <span class="font-semibold text-dark">INR 2000/ session + 18% GST</span>
      </p>
    </div>
    <Bcard class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bcard from "./Bcard.vue";

export default {
  props: ["location"],
  components: {
    Bcard,
  },
  data() {
    return {
      dataFound: false,
      serviceName: "",
      cardView: false,
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
  },
  methods: {
    async handleService() {
      this.userDetails = sessionStorage.getItem("token");
      try {
        // if (this.userDetails === null) {
        //   this.$swal
        //     .fire({
        //       title: "Login!",
        //       text: "Please login to continue",
        //       icon: "info",
        //       confirmButtonText: "Okay",
        //       confirmButtonColor: "#830c81",
        //       showCancelButton: false,
        //     })
        //     .then((result) => {
        //       return this.$router.push({ name: "signin" });
        //     });
        //   return;
        // }
        this.cardView = !this.cardView;
        let payload = {
          service: this.serviceName,
        };
        let data = await this.$store.dispatch(
          "respitecare/getVolunteerByService",
          payload
        );
      } catch (error) {
        console.log(error);
      }

      // this.$router.push({ name: "map-inside", query: { service: true } });
      // let urlToRedirect = `${window.location.origin}/product-services`;
      // localStorage.setItem("bookService", true);
      // window.open(urlToRedirect, "_blank");
    },
    handleRoute(name, params) {
      this.$router.push({ name: name, params: { pathName: params } });
    },
  },
  mounted() {
    if (this.get_volunteer_by_location.length > 0) {
      this.dataFound = true;
    }
    this.serviceName = this.$route.query.service;
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.fsize30 {
  font-size: 30px;
}
</style>
